import facetedFiltersConfig from "~/config/faceted-filters.json";

export type FacetedFilterDefinition = {
  displayName: string;
  needName: string;
  requestName: string;
};

type RawFilterDefinition = Partial<FacetedFilterDefinition>;

type RawFacetedFiltersConfig = {
  default?: RawFilterDefinition[];
  groups?: Record<string, RawFilterDefinition[]>;
  typeSizeSearch?: Record<
    string,
    {
      diameter?: RawFilterDefinition;
      size?: RawFilterDefinition;
    }
  >;
};

export type TypeSizeFilterDefinitions = {
  diameter: FacetedFilterDefinition;
  size: FacetedFilterDefinition;
};

const config = facetedFiltersConfig as RawFacetedFiltersConfig;

const normalizeDefinition = (
  definition: RawFilterDefinition,
): FacetedFilterDefinition | null => {
  const displayName = definition.displayName?.trim();
  const needName = definition.needName?.trim();
  const requestName = definition.requestName?.trim() || needName;

  if (!displayName || !needName || !requestName) {
    return null;
  }

  return {
    displayName,
    needName,
    requestName,
  };
};

const normalizeDefinitions = (definitions: RawFilterDefinition[] = []) =>
  definitions
    .map(normalizeDefinition)
    .filter((definition): definition is FacetedFilterDefinition =>
      Boolean(definition),
    );

const getDefinitionsForGroup = (groupId: number) =>
  config.groups?.[String(groupId)] ?? config.default ?? [];

export const getFacetedFilterDefinitions = (groupId: number) =>
  normalizeDefinitions(getDefinitionsForGroup(groupId));

export const getTypeSizeFilterDefinitions = (
  groupId: number,
): TypeSizeFilterDefinitions => {
  const groupConfig =
    config.typeSizeSearch?.[String(groupId)] ?? config.typeSizeSearch?.default;
  const diameter = normalizeDefinition(groupConfig?.diameter ?? {});
  const size = normalizeDefinition(groupConfig?.size ?? {});

  return {
    diameter:
      diameter ??
      ({
        displayName: "Посадочный диаметр",
        needName: "Посадочный диаметр, дюйм (Шины)",
        requestName: "Посадочный диаметр, дюйм",
      } satisfies FacetedFilterDefinition),
    size:
      size ??
      ({
        displayName: "Типоразмер",
        needName: "Типоразмер / мм",
        requestName: "Типоразмер",
      } satisfies FacetedFilterDefinition),
  };
};
